import React, { useEffect } from 'react';
import { AppContext } from '../../App';

const Portfolio = () => {
  const { addListeners } = React.useContext(AppContext);
  useEffect(() => {
    addListeners();
    var element = document.querySelector('#portfolio-flters li');
    setTimeout(() => simulateMouseClick(element), 1000);
    return () => {
      //removeListeners();
    };
  }, []);

  const mouseClickEvents = ['click'];
  function simulateMouseClick(element) {
    mouseClickEvents.forEach((mouseEventType) =>
      element.dispatchEvent(
        new MouseEvent(mouseEventType, {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1,
        })
      )
    );
  }

  return (
    <main id="main" style={{ minHeight: '100vh' }}>
      <section className="d-flex align-items-center"></section>
      <section id="portfolio" className="portfolio">
        <div className="container">
          <div className="section-title">
            <span>Portfolio</span>
            <h2>Portfolio</h2>
            <p>JLAB design and products</p>
          </div>

          <div className="row">
            <div className="col-lg-12 d-flex justify-content-center">
              <ul id="portfolio-flters">
                <li data-filter="*" className="filter-active">
                  All
                </li>
                <li data-filter=".filter-mechanical">Mechanical design</li>
                <li data-filter=".filter-electronic">Electronic design</li>
                <li data-filter=".filter-jlabsmartcnc">JLABsmartCNC</li>
              </ul>
            </div>
          </div>

          <div className="row portfolio-container">
            <div className="col-lg-4 col-md-6 portfolio-item filter-mechanical">
              <img
                src="assets/img/portfolio/mechanical_design/CNCLathe SheetMetal Cover.Var3.png"
                className="img-fluid"
                alt=""
              />
              <div className="portfolio-info">
                <h4>CNCLathe SheetMetal Cover.Var3</h4>
                <a
                  href="assets/img/portfolio/mechanical_design/CNCLathe SheetMetal Cover.Var3.png"
                  data-gallery="portfolioGallery"
                  className="portfolio-lightbox preview-link"
                  title="CNCLathe SheetMetal Cover.Var3"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item filter-mechanical">
              <img
                src="assets/img/portfolio/mechanical_design/Cobot_Table.png"
                className="img-fluid"
                alt=""
              />
              <div className="portfolio-info">
                <h4>Cobot Table</h4>
                <a
                  href="assets/img/portfolio/mechanical_design/Cobot_Table.png"
                  data-gallery="portfolioGallery"
                  className="portfolio-lightbox preview-link"
                  title="Cobot Table"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item filter-mechanical">
              <img
                src="assets/img/portfolio/mechanical_design/Gel.jpg"
                className="img-fluid"
                alt=""
              />
              <div className="portfolio-info">
                <h4>Gel</h4>
                <a
                  href="assets/img/portfolio/mechanical_design/Gel.jpg"
                  data-gallery="portfolioGallery"
                  className="portfolio-lightbox preview-link"
                  title="Gel"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 portfolio-item filter-electronic">
              <img
                src="assets/img/portfolio/electronic_design/Alarm system.jpg"
                className="img-fluid"
                alt=""
              />
              <div className="portfolio-info">
                <h4>Alarm system</h4>
                <a
                  href="assets/img/portfolio/electronic_design/Alarm system.jpg"
                  data-gallery="portfolioGallery"
                  className="portfolio-lightbox preview-link"
                  title="Alarm system"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item filter-electronic">
              <img
                src="assets/img/portfolio/electronic_design/Energy meter.jpg"
                className="img-fluid"
                alt=""
              />
              <div className="portfolio-info">
                <h4>Energy meter</h4>
                <a
                  href="assets/img/portfolio/electronic_design/Energy meter.jpg"
                  data-gallery="portfolioGallery"
                  className="portfolio-lightbox preview-link"
                  title="Energy meter"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item filter-electronic">
              <img
                src="assets/img/portfolio/electronic_design/GSM controller.jpg"
                className="img-fluid"
                alt=""
              />
              <div className="portfolio-info">
                <h4>GSM controller</h4>
                <a
                  href="assets/img/portfolio/electronic_design/GSM controller.jpg"
                  data-gallery="portfolioGallery"
                  className="portfolio-lightbox preview-link"
                  title="GSM controller"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 portfolio-item filter-jlabsmartcnc">
              <img
                src="assets/img/portfolio/JLABsmartCNC/JLABsmartCNC1.png"
                className="img-fluid"
                alt=""
              />
              <div className="portfolio-info">
                <h4>JLABsmartCNC 1</h4>
                <a
                  href="assets/img/portfolio/JLABsmartCNC/JLABsmartCNC1.png"
                  data-gallery="portfolioGallery"
                  className="portfolio-lightbox preview-link"
                  title="JLABsmartCNC 1"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item filter-jlabsmartcnc">
              <img
                src="assets/img/portfolio/JLABsmartCNC/JLABsmartCNC2.png"
                className="img-fluid"
                alt=""
              />
              <div className="portfolio-info">
                <h4>JLABsmartCNC 2</h4>
                <a
                  href="assets/img/portfolio/JLABsmartCNC/JLABsmartCNC2.png"
                  data-gallery="portfolioGallery"
                  className="portfolio-lightbox preview-link"
                  title="JLABsmartCNC 2"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 portfolio-item filter-jlabsmartcnc">
              <img
                src="assets/img/portfolio/JLABsmartCNC/JLABsmartCNC3.png"
                className="img-fluid"
                alt=""
              />
              <div className="portfolio-info">
                <h4>JLABsmartCNC 3</h4>
                <a
                  href="assets/img/portfolio/JLABsmartCNC/JLABsmartCNC3.png"
                  data-gallery="portfolioGallery"
                  className="portfolio-lightbox preview-link"
                  title="JLABsmartCNC 3"
                >
                  <i className="bx bx-plus"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Portfolio;
